import {
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  ReloadOutlined,
  RightOutlined,
  SaveOutlined,
} from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import { Button, Row, DatePicker, Radio, Col, notification, Tooltip } from 'antd'
import React, { useEffect, useState, useContext, useRef } from 'react'
import 'styleLess/signature/reschedule.scss'
import moment from 'moment'
import { getScheduleById, projectScheduleAutoEdit } from 'api/Reschedule/schedule'
import { postholiday } from 'api/Project/sprintFlow'
import { getCookie } from 'helper/cookie'
import { CounterContext } from 'redux/Golbalvalues'
import ModalSaveRescd from 'common/Reschedule/modalSaveRescd'
import ModalHistory from 'common/Reschedule/modalHistory'
import ModalErrAuto from 'common/Reschedule/modalErrAuto'
import { useHistory } from 'react-router'
import { getScheduleViewlog } from 'api/Reschedule/schedule'
import {
  getFlowScheduleCheck,
  scheduleSubtaskEdit,
  scheduleSubtaskDelete,
} from 'api/Reschedule/schedule'
import ModalSaveChange from 'common/Project/modalSaveChange'
import { getauthorityUser } from 'api/Account/permission'
import styled from 'styled-components'
const { RangePicker } = DatePicker
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
  line-height: 2;
`

const Reschedule = () => {
  const iniStatusStyle = 'In Progress'
  const firstUpdate = useRef(true)
  const [data_log, setData_log] = useState([])
  const { id } = useParams()
  const history = useHistory()
  let project_id = parseInt(id)
  const {
    setDirty,
    setData_common_reschedule,
    setPathActive,
    setDisableSave,
    isDirty,
    setClick_path,
    click_path,
    disableSave,
  } = useContext(CounterContext)
  const [isLoading, setIsLoading] = useState(false)
  const [visibleHistory, setVisibleHistory] = useState(false)
  const [visibleModalSaveRescd, setVisibleModalSaveRescd] = useState(false)
  const token = getCookie('access_token_admin')
  const [wrt, setWrt] = useState(false)
  const [dataschedule, setDataschedule] = useState()
  const [dataTable, setDatatable] = useState([])
  const [dataHeader, setDataheader] = useState()
  const [structDate, setStructDate] = useState([])
  const [valueRadio, setValueRadio] = useState(1)
  const [visibleSaveChange, setVisibleSaveChange] = useState(false)
  const [onChangeData, setOnChangeData] = useState(false)
  const [overlap, setOverlap] = useState({
    status: true,
    configDate: true,
    err_flow: 'N',
    working_day: true,
  })
  const [accessRole, setAccessrole] = useState(false)
  //check repeat notification
  const [id_onChange, setId_onChange] = useState('')
  // word
  const Err_text1 = 'Task schedule need to be in scope of a project'
  const Err_text1_1 = 'Subtask schedule need to be in scope of a project'
  const Err_text2 = 'Subtask schedule need to be in scope of a task'
  const Err_text3 = 'Task schedule in scope mandatory'
  const getErrorflow = async () => {
    await getFlowScheduleCheck({
      id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (status === 200) {
          setOverlap((prev) => ({
            ...prev,
            err_flow: data.err_check,
          }))
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  const getDataViewlog = async () => {
    await getScheduleViewlog({
      id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setData_log([])
          return true
        }
        if (status === 200) {
          setData_log(data)
        } else {
          setData_log([])
          return true
        }
      })
      .catch((error) => {
        setData_log([])
        console.error(error)
      })
  }
  const FetchScheduleByid = () => {
    try {
      getScheduleById({
        id: project_id,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (status === 200) {
          setDataschedule(data)
        } else {
          setDataschedule([])
        }
      })
    } catch (error) {
      setDataschedule([])
      console.log(error)
    }
  }
  const getroleAuthority = async () => {
    await getauthorityUser({
      id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          if (![1, 2, 3].includes(data.role_id) && ![1].includes(data.accountrole_id)) {
            setAccessrole(false)
            history.push('/no-permission')
            setPathActive('')
          } else {
            setAccessrole(true)
          }
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  const DeleteBufferSubtask = () => {
    try {
      scheduleSubtaskDelete({
        project_id: project_id,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
      })
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (token) {
      DeleteBufferSubtask()
      getroleAuthority()
    }
  }, [token])
  useEffect(() => {
    if (token && accessRole === true) {
      getDataViewlog()
      FetchScheduleByid()
      getErrorflow()
      setPathActive('/project-list')
    }
  }, [accessRole])
  const transformDataSchedule = () => {
    //ปั้นหัว
    const structProjectdate = {
      project_id: project_id,
      status: dataschedule.status,
      name: dataschedule.name,
      status_id: dataschedule.status_id,
      closure: dataschedule.closure,
      kickoff: dataschedule.kickoff,
    }
    setDataheader(structProjectdate)
    // ปั้นตาราง
    let data = []
    let log_Done = []
    dataschedule.sprintflow?.map((item) => {
      let TextColorCode = '#000'
      let Blocked_start = false
      let Blocked_end = false
      let Between_task_start = item.plan_start
      let Between_task_end = item.plan_end
      let state_config = false
      let workingDays_task = item.working_day
      let plan_start = ''
      let plan_end = ''
      if (item.flow_status === 'Done') {
        TextColorCode = '#00B7A3'
        Blocked_start = true
        Blocked_end = true
        log_Done.push(item)
      } else if (item.flow_status === 'In Progress') {
        log_Done.push(item)
        Blocked_start = true
      }
      let arr = []
      item.sprintflow?.map((my) => {
        if (my.flow_status === 'Done') {
          arr.push(my)
        }
      })
      let st_date = ''
      let ed_date = ''
      if (arr.length >= 1) {
        if (arr[0]?.plan_start !== undefined && arr[0]?.plan_end) {
          st_date = arr[0]?.plan_start
          ed_date = arr[0]?.plan_end
        }

        arr.map((item) => {
          const st_default = new Date(st_date)
          const ed_default = new Date(ed_date)
          const st_value = new Date(item.plan_start)
          const ed_value = new Date(item.plan_end)
          if (st_value < st_default) {
            st_date = item.plan_start
          }
          // and if
          if (ed_value > ed_default) {
            ed_date = item.plan_end
          }
        })
      }

      if (item.plan_end === '' || item.plan_start === '') {
        plan_end = null
        plan_start = null
      } else {
        plan_start = item.plan_start
        plan_end = item.plan_end
      }

      const createtask = {
        id: item.sprintflow_id,
        title: item.name,
        plan_end: plan_end,
        plan_start: plan_start,
        day: workingDays_task,
        status: item.flow_status,
        closure: dataschedule.closure,
        kickoff: dataschedule.kickoff,
        bgcolorCode: '#F3F6F9',
        textcolorCode: TextColorCode,
        task_type: item.task_type,
        type: 'task',
        disabled_start: Blocked_start,
        disabled_end: Blocked_end,
        working_hour: item.working_hour,
        config_date: state_config,
        config_mandatory: false,
        tooltext: '',
        bts: st_date,
        bte: ed_date,
      }
      data.push(createtask)

      item.sprintflow?.map((item2) => {
        let TextColorCode = '#000'
        let Blocked_start = false
        let Blocked_end = false
        let state_config_subtask = false
        let workingDays_subtask = item2.working_day

        if (item2.flow_status === 'Done') {
          TextColorCode = '#00B7A3'
          Blocked_start = true
          Blocked_end = true
          log_Done.push(item2)
        } else if (item2.flow_status === 'In Progress') {
          log_Done.push(item2)
          Blocked_start = true
        }
        if ([null].includes(dataHeader?.closure)) {
          Blocked_start = true
          Blocked_end = true
        }
        const createsubtask = {
          id: item2.sprintflow_id,
          sub_id: item.sprintflow_id,
          title: item2.name,
          plan_end: item2.plan_end,
          plan_start: item2.plan_start,
          day: workingDays_subtask,
          status: item2.flow_status,
          bgcolorCode: '#fff',
          textcolorCode: TextColorCode,
          type: 'subtask',
          disabled_start: Blocked_start,
          disabled_end: Blocked_end,
          working_hour: item2.working_hour,
          level_id: item2.level_id,
          config_date: state_config_subtask,
          tooltext: '',
          bts: Between_task_start,
          bte: Between_task_end,
        }
        data.push(createsubtask)
      })
    })
    setDatatable(data)
    if (![null, undefined, ''].includes(log_Done)) {
      rendererDateQuery(log_Done)
    }
    setWrt(true)
  }

  useEffect(() => {
    if (dataschedule) {
      transformDataSchedule()
    }
  }, [dataschedule])

  useEffect(() => {
    if (dataTable) {
      let data_task = []
      dataTable.map((item) => {
        let data_subtask = []
        dataTable.map((item2) => {
          if (item.id === item2.level_id) {
            data_subtask.push({
              title: item2.title,
              sprintflow_id: item2.id,
              plan_start: item2.plan_start,
              plan_end: item2.plan_end,
            })
          }
        })
        if (item.type === 'task') {
          if (data_subtask.length > 0) {
            data_task.push({
              title: item.title,
              sprintflow_id: item.id,
              plan_start: item.plan_start,
              plan_end: item.plan_end,
              sprintflow: data_subtask,
            })
          } else {
            data_task.push({
              title: item.title,
              sprintflow_id: item.id,
              plan_start: item.plan_start,
              plan_end: item.plan_end,
            })
          }
        }
      })
      setData_common_reschedule({
        project_id: project_id,
        kickoff: dataHeader?.kickoff,
        closure: dataHeader?.closure,
        sprintflow: data_task,
      })
    }
  }, [dataTable, dataHeader])
  const rendererDateQuery = async (Struct) => {
    let st_date = ''
    let ed_date = ''
    if (Struct[0]?.plan_start !== undefined && Struct[0]?.plan_end) {
      st_date = Struct[0]?.plan_start
      if (Struct[0]?.flow_status === 'In Progress') {
        ed_date = Struct[0]?.plan_start
      } else {
        ed_date = Struct[0]?.plan_end
      }
    }

    await Struct.map((item) => {
      const st_default = new Date(st_date)
      const st_value = new Date(item.plan_start)
      if (st_value < st_default) {
        st_date = item.plan_start
      }
      if (item.flow_status === 'Done') {
        const ed_default = new Date(ed_date)
        const ed_value = new Date(item.plan_end)
        if (ed_value > ed_default) {
          ed_date = item.plan_end
        }
      } else if (item.flow_status === 'In Progress') {
        const ed_default = new Date(ed_date)
        const ed_value = new Date(item.plan_start)
        if (ed_value > ed_default) {
          ed_date = item.plan_start
        }
      }
      // and if
    })

    setStructDate({
      plan_start: st_date,
      plan_end: ed_date,
    })
  }

  const openNotificationWithIcon = (type, des) => {
    notification[type]({
      description: des,
      duration: 2,
    })
  }

  const onChangeRadio = (e) => {
    // auto
    if (e.target.value === 2) {
      if (
        overlap.status &&
        overlap.configDate &&
        overlap.working_day &&
        overlap.err_flow === 'N'
      ) {
        FetchScheduleByid()
        setValueRadio(e.target.value)
      } else {
        setVisibleErrAuto(true)
        setValueRadio(1)
      }
    } else {
      setValueRadio(e.target.value)
      FetchScheduleByid()
    }
  }
  const onChangplanProject = (value, dateString) => {
    onChangeTaskProject(dateString, '', 'project')
    setDirty(true)
    setOnChangeData(true)
    if ([undefined, ''].includes(dateString[0])) {
      setDataheader((prev) => ({
        ...prev,
        closure: null,
        kickoff: null,
      }))
    } else {
      setDataheader((prev) => ({
        ...prev,
        closure: dateString[1],
        kickoff: dateString[0],
      }))
    }
    PROJECT_CHANGED_DAYS(dateString)
  }

  const [dateLimit, setDateLimit] = useState({ way: '', value2: '' })
  const onChangeDateTask = async (dateString, value) => {
    setDirty(true)
    setOnChangeData(true)
    if (dateString !== null) {
      let st = moment(dateString[0]).format('YYYY-MM-DD')
      let end = moment(dateString[1]).format('YYYY-MM-DD')
      const dataArray = {
        project_id: project_id,
        plan_start: st,
        plan_end: end,
        working_hour: value.working_hour,
      }
      const dataSubtask = {
        project_id: project_id,
        sprintflow_id: value.id,
        plan_start: st,
        plan_end: end,
      }
      // schedule subtask edit save buffer
      if (value.type === 'subtask') {
        try {
          await scheduleSubtaskEdit({
            params: dataSubtask,
            token: token,
          }).then((response) => {
            const { status, data, error } = response
          })
        } catch (error) {
          console.log(error)
        }
      }

      if (
        dataArray.plan_start != 'Invalid date' &&
        dataArray.plan_end != 'Invalid date'
      ) {
        try {
          await postholiday({
            params: dataArray,
            token: token,
          }).then((response) => {
            const { status, data, error } = response
            if (status === 200) {
              const structTaskchange = {
                struct_id: value.id,
                struct_working_days: data.working_days,
                struct_start: st,
                struct_end: end,
                struct_type: value.type,
                struct_task_type: value.task_type,
              }
              TASK_CHANGED_DAYS(structTaskchange)
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
      let arrMandatory = []

      dataTable?.map((my, index) => {
        if (my.type === 'task') {
          if (my.task_type == 'M') {
            if (value.id != my.id) {
              arrMandatory.push(my)
            }
          }
        }
      })

      if (arrMandatory.length > 0) {
        if (selectRange == 'start') {
          let st_date = moment(dataHeader.closure).add(1, 'days').format('YYYY-MM-DD')
          arrMandatory.map((item) => {
            const st_default = new Date(st_date)
            const st_value = new Date(item.plan_start)
            const selectDate = new Date(dateString[0])
            if (st_value >= selectDate) {
              if (st_value < st_default) {
                st_date = item.plan_start
              }
            }
          })
          setDateLimit({ way: 'start', value2: st_date })
        } else {
          // check empty rang picker
          let st_date = value.plan_start
            ? moment(dataHeader.kickoff).add(-1, 'days').format('YYYY-MM-DD')
            : moment(dataHeader.kickoff).format('YYYY-MM-DD')
          arrMandatory.map((item) => {
            const st_default = new Date(st_date)
            const st_value = new Date(item.plan_end)
            const selectDate = new Date(dateString[1])
            if (st_value <= selectDate) {
              if (st_value > st_default) {
                //check empty range picker
                st_date = value.plan_start
                  ? item.plan_end
                  : moment(item.plan_end).add(1, 'days').format('YYYY-MM-DD')
              }
            }
          })
          setDateLimit({ way: 'end', value2: st_date })
        }
      }
    } else {
      const structTaskchange = {
        struct_id: value.id,
        struct_working_days: 0,
        struct_start: null,
        struct_end: null,
        struct_type: value.type,
        struct_task_type: value.task_type,
      }
      TASK_CHANGED_DAYS(structTaskchange)
    }
  }
  const onBlur = (e) => {
    if (e.target.value) {
    } else {
      setDateLimit({ way: '' })
    }
  }
  const onOpenChangePlanProject = (e) => {
    //check notification ให้ขึ้นครั้งเดียว
    if (!e) {
      setId_onChange('')
    }
  }

  const onOpenChange = (e, item) => {
    if (e == true && item.type === 'task') {
      setDateLimit({ way: '' })
    }
    //check notification ให้ขึ้นครั้งเดียว
    if (!e) {
      setId_onChange('')
    }
  }
  const PROJECT_CHANGED_DAYS = async (val) => {
    let default_project_start = new Date(val[0])
    let default_project_end = new Date(val[1])
    let arrMandatory = []
    let handleStart = '' // for task
    let handleEnd = '' // for task
    await dataTable.map((item) => {
      if (item.task_type === 'M') {
        arrMandatory.push(item)
      }
    })
    setDatatable([
      ...dataTable,
      dataTable?.map((item) => {
        let IdateStart = new Date(item.plan_start)
        let IdateEnd = new Date(item.plan_end)

        let Validate_Task_start = new Date(handleStart)
        let Validate_Task_end = new Date(handleEnd)
        if (item.type === 'task') {
          handleStart = item.plan_start
          handleEnd = item.plan_end
        }

        if (IdateStart < default_project_start || IdateEnd > default_project_end) {
          item.config_date = true
          if (item.type === 'task') {
            item.tooltext = Err_text1
          } else if (item.type === 'subtask') {
            item.tooltext = Err_text1_1
          }
        } else {
          if (item.type === 'subtask') {
            let start = new Date(item.plan_start)
            let end = new Date(item.plan_end)

            if (start < Validate_Task_start || end > Validate_Task_end) {
              item.tooltext = Err_text2
              item.config_date = true
            } else {
              item.tooltext = ''
              item.config_date = false
            }
          } else {
            item.tooltext = ''
            item.config_date = false
          }
        }
        if (arrMandatory.length != 0) {
          if (item.type === 'task') {
            let task_start = new Date(item.plan_start)
            let task_end = new Date(item.plan_end)
            let count = 0
            let text = item.tooltext
            if (item.tooltext === '') {
              text = Err_text3
            }

            arrMandatory.map((m) => {
              let manStart = new Date(m.plan_start)
              let manEnd = new Date(m.plan_end)

              if (task_start < manStart && task_end > manEnd) {
                item.config_mandatory = true
                if (item.tooltext == '') {
                  item.tooltext = text
                }
              } else if (item.id != m.id) {
                if (
                  item.plan_start === m.plan_start ||
                  item.plan_end === m.plan_end ||
                  item.plan_start === m.plan_end ||
                  item.plan_end === m.plan_start
                ) {
                  //case => equal
                  item.config_mandatory = true
                  if (item.tooltext == '') {
                    item.tooltext = text
                  }
                } else if (task_start > manStart && task_end < manEnd) {
                  //case => |start end|
                  item.config_mandatory = true
                  if (item.tooltext == '') {
                    item.tooltext = text
                  }
                } else if (
                  task_start < manStart &&
                  task_end > manStart &&
                  task_end < manEnd
                ) {
                  //case => start | end|
                  item.config_mandatory = true
                  if (item.tooltext == '') {
                    item.tooltext = text
                  }
                } else if (
                  task_start > manStart &&
                  task_start < manEnd &&
                  task_end > manEnd
                ) {
                  //case => |start |end
                  item.config_mandatory = true
                  if (item.tooltext == '') {
                    item.tooltext = text
                  }
                }
              } else {
                count = count + 1
                if (count == arrMandatory.length) {
                  item.config_mandatory = false
                }
              }
            })
          }
        }
      }),
    ])
    const newData = dataTable.filter((item) => item != undefined)
    setDatatable(newData)
    setWrt(false)
  }
  const TASK_CHANGED_DAYS = async (val) => {
    let defaultTask_start = new Date(val.struct_start)
    let defaultTask_end = new Date(val.struct_end)
    let initial_start = ''
    let initial_end = ''
    let arrMandatory = []
    await dataTable.map((item) => {
      if (item.task_type === 'M') {
        arrMandatory.push(item)
      }
    })

    setDatatable([
      ...dataTable,
      dataTable.map((item) => {
        let start = new Date(item.plan_start)
        let end = new Date(item.plan_end)
        if (val.struct_id == item.sub_id) {
          if (defaultTask_start > start || defaultTask_end < end) {
            item.tooltext = Err_text2

            item.config_date = true
          } else {
            item.config_date = false
          }
          item.bts = val.struct_start
          item.bte = val.struct_end
        }
        if (item.type === 'task') {
          initial_start = item.plan_start
          initial_end = item.plan_end
        }

        if (val.struct_id == item.id) {
          item.plan_start = val.struct_start
          item.plan_end = val.struct_end
          item.day = val.struct_working_days

          if (item.type === 'task') {
            let project_closure = new Date(dataHeader.closure)
            let project_kickoff = new Date(dataHeader.kickoff)
            if (
              defaultTask_start < project_kickoff ||
              defaultTask_end > project_closure ||
              val.struct_start === null ||
              val.struct_end === null
            ) {
              item.tooltext = Err_text1
              item.config_date = true
            } else {
              item.tooltext = ''
              item.config_date = false
            }
          } else if (item.type === 'subtask') {
            let current_task_start = new Date(initial_start)
            let current_task_end = new Date(initial_end)
            if (
              current_task_start > defaultTask_start ||
              current_task_end < defaultTask_end
            ) {
              item.tooltext = Err_text2
              item.config_date = true
            } else {
              item.config_date = false
            }
          }
        }
        if (arrMandatory.length != 0 && val.struct_type !== 'subtask') {
          let purgeState = false
          let DrunkinState = false
          arrMandatory.map((m, mdx) => {
            let manStart = new Date(m.plan_start)
            let manEnd = new Date(m.plan_end)
            if (item.type === 'task' && val.struct_task_type === 'M' && item.id != m.id) {
              if (val.struct_id == item.id) {
                if (defaultTask_start > manStart && defaultTask_end < manEnd) {
                  // error case => |start end|
                  item.config_mandatory = true
                  item.tooltext = Err_text3
                } else if (defaultTask_start < manStart && defaultTask_end > manEnd) {
                  // error case => start| |end
                  item.config_mandatory = true
                  item.tooltext = Err_text3
                } else if (
                  defaultTask_start < manStart &&
                  defaultTask_end > manStart &&
                  defaultTask_end < manEnd
                ) {
                  // error case => start|end |
                  item.config_mandatory = true
                  item.tooltext = Err_text3
                } else if (
                  defaultTask_start > manStart &&
                  defaultTask_start < manEnd &&
                  defaultTask_end > manEnd
                ) {
                  // error case => | start|end
                  item.config_mandatory = true
                  item.tooltext = Err_text3
                } else if (
                  m.plan_start === val.struct_end ||
                  m.plan_start === val.struct_start ||
                  m.plan_end === val.struct_start ||
                  m.plan_end === val.struct_end
                ) {
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                } else {
                  item.config_mandatory = false
                }
              } else {
                if (m.id != val.struct_id && purgeState === false) {
                  if (start > manStart && end < manEnd) {
                    // case |start end|
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (start < manStart && end > manEnd) {
                    // case start| |end
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (start > manStart && start < manEnd && end > manEnd) {
                    // case |start |end
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (start < manStart && end > manStart && end < manEnd) {
                    // case start| end|
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (
                    item.plan_start === m.plan_start ||
                    item.plan_start === m.plan_end ||
                    item.plan_end === m.plan_start ||
                    item.plan_end === m.plan_end
                  ) {
                    // case equal error
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else {
                    if (start > defaultTask_start && end < defaultTask_end) {
                      // case |start end|
                      item.config_mandatory = true
                      item.tooltext = Err_text3
                      purgeState = true
                    } else if (start < defaultTask_start && end > defaultTask_end) {
                      // case start| |end
                      item.config_mandatory = true
                      item.tooltext = Err_text3
                      purgeState = true
                    } else if (
                      start > defaultTask_start &&
                      start < defaultTask_end &&
                      end > defaultTask_end
                    ) {
                      // case |  start|end
                      item.config_mandatory = true
                      item.tooltext = Err_text3
                      purgeState = true
                    } else if (
                      start < defaultTask_start &&
                      end > defaultTask_start &&
                      end < defaultTask_end
                    ) {
                      // case start|end  |
                      item.config_mandatory = true
                      item.tooltext = Err_text3
                      purgeState = true
                    } else if (
                      item.plan_start === val.struct_start ||
                      item.plan_start === val.struct_end ||
                      item.plan_end === val.struct_start ||
                      item.plan_end === val.struct_end
                    ) {
                      // case equal error
                      item.config_mandatory = true
                      item.tooltext = Err_text3
                      purgeState = true
                    } else {
                      item.config_mandatory = false
                      item.tooltext = ''
                    }
                  }
                } else if (purgeState === false) {
                  if (start > defaultTask_start && end < defaultTask_end) {
                    // case |start end|
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (start < defaultTask_start && end > defaultTask_end) {
                    // case start| |end
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (
                    start > defaultTask_start &&
                    start < defaultTask_end &&
                    end > defaultTask_end
                  ) {
                    // case |  start|end
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (
                    start < defaultTask_start &&
                    end > defaultTask_start &&
                    end < defaultTask_end
                  ) {
                    // case start|end  |
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else if (
                    item.plan_start === val.struct_start ||
                    item.plan_start === val.struct_end ||
                    item.plan_end === val.struct_start ||
                    item.plan_end === val.struct_end
                  ) {
                    // case equal error
                    item.config_mandatory = true
                    item.tooltext = Err_text3
                    purgeState = true
                  } else {
                    item.config_mandatory = false
                    item.tooltext = ''
                  }
                }
              }
            } else if (
              item.type === 'task' &&
              val.struct_task_type !== 'M' &&
              item.id != m.id
            ) {
              if (item.id === val.struct_id) {
                if (defaultTask_start > manStart && defaultTask_end < manEnd) {
                  // case ---- |start end|
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                } else if (defaultTask_start < manStart && defaultTask_end > manEnd) {
                  //case ---- start| |end
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                } else if (
                  defaultTask_start > manStart &&
                  defaultTask_start < manEnd &&
                  defaultTask_end > manEnd
                ) {
                  //case ---- | start|end
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                } else if (
                  defaultTask_start < manStart &&
                  defaultTask_end > manStart &&
                  defaultTask_end < manEnd
                ) {
                  //case ----  start| end|
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                } else if (
                  val.struct_start === m.plan_start ||
                  val.struct_start === m.plan_end ||
                  val.struct_end === m.plan_start ||
                  val.struct_end === m.plan_end
                ) {
                  //case --- equal
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                } else {
                  item.tooltext = ''
                  item.config_mandatory = false
                }
              } else if (DrunkinState === false && item.task_type === 'M') {
                if (start > manStart && end < manEnd) {
                  // case ---- |start end|
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                  DrunkinState = true
                } else if (start < manStart && end > manEnd) {
                  //case ---- start| |end
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                  DrunkinState = true
                } else if (start > manStart && start < manEnd && end > manEnd) {
                  //case ---- | start|end
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                  DrunkinState = true
                } else if (start < manStart && end > manStart && end < manEnd) {
                  //case ----  start| end|
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                  DrunkinState = true
                } else if (
                  item.plan_start === m.plan_start ||
                  item.plan_start === m.plan_end ||
                  item.plan_end === m.plan_start ||
                  item.plan_end === m.plan_end
                ) {
                  //case ----  equal
                  item.tooltext = Err_text3
                  item.config_mandatory = true
                  DrunkinState = true
                } else {
                  //ถ้ามันรอดเคสด้านบนแล้วค่อยมาเช็คต่อ

                  if (defaultTask_start > start && defaultTask_end < end) {
                    // case ---- |start end|
                    item.tooltext = Err_text3
                    item.config_mandatory = true
                    DrunkinState = true
                  } else if (defaultTask_start < start && defaultTask_end > end) {
                    //case ---- start| |end
                    item.tooltext = Err_text3
                    item.config_mandatory = true
                    DrunkinState = true
                  } else if (
                    defaultTask_start > start &&
                    defaultTask_start < end &&
                    defaultTask_end > end
                  ) {
                    //case ---- | start|end
                    item.tooltext = Err_text3
                    item.config_mandatory = true
                    DrunkinState = true
                  } else if (
                    defaultTask_start < start &&
                    defaultTask_end > start &&
                    defaultTask_end < end
                  ) {
                    //case ----  start| end|
                    item.tooltext = Err_text3
                    item.config_mandatory = true
                    DrunkinState = true
                  } else {
                    item.tooltext = ''
                    item.config_mandatory = false
                  }
                }
              }
            }
          })
        }
      }),
    ])
    const newData = dataTable.filter((item) => item != undefined)
    setDatatable(newData)
  }
  const disableDateProject = (current) => {
    if (structDate.plan_start != '' && structDate.plan_end != '') {
      if (selectRange == 'start') {
        return current > moment(structDate.plan_start)
      } else {
        return current < moment(structDate.plan_end)
      }
    }
  }
  const disableDateTask = (current, value) => {
    if (value.type === 'subtask') {
      return current < moment(value.bts) || current > moment(value.bte)
    } else if (value.type === 'task') {
      let st_date = ''
      let ed_date = ''
      let arr = []

      let arrMandatory = []

      dataTable?.map((my, index) => {
        if (my.type === 'subtask') {
          if (value.id == my.level_id) {
            if (my.status === 'Done' || my.status === 'In Progress') {
              arr.push(my)
            }
          }
        }
        if (my.type === 'task') {
          if (my.task_type == 'M') {
            arrMandatory.push(my)
          }
        }
      })

      if (dateLimit.way == 'start') {
        return current >= moment(dateLimit.value2)
      } else if (dateLimit.way == 'end') {
        return current <= moment(dateLimit.value2)
      } else {
        if (arr.length >= 1) {
          if (arr[0]?.plan_start !== undefined && arr[0]?.plan_end) {
            st_date = arr[0]?.plan_start
            ed_date = arr[0].status == 'In Progress' ? '0000-01-01' : arr[0]?.plan_end
          }
          let disableInprogressSubtask = ''
          arr.map((item) => {
            const st_default = new Date(st_date)
            const ed_default = new Date(ed_date)
            const st_value = new Date(item.plan_start)
            const ed_value = new Date(
              item.status == 'In Progress' ? '0000-01-01' : item.plan_end,
            )
            if (st_value < st_default) {
              st_date = item.plan_start
            }
            if (st_value >= st_default) {
              disableInprogressSubtask = item.plan_start
            }
            if (ed_value > ed_default) {
              ed_date = item.status == 'In Progress' ? '0000-01-01' : item.plan_end
            }
          })
          if (selectRange == 'start') {
            return functioncheckMandatory(
              arrMandatory,
              //check empty range picker
              value.plan_start
                ? current < moment(dataHeader.kickoff) || current > moment(st_date)
                : current > moment(st_date).add(1, 'days'),
              current,
              value,
            )
          } else {
            return functioncheckMandatory(
              arrMandatory,
              //check empty range picker
              value.plan_start
                ? current > moment(dataHeader.closure) ||
                    current < moment(ed_date) ||
                    current < moment(disableInprogressSubtask)
                : current > moment(dataHeader.closure).add(1, 'days') ||
                    current < moment(ed_date).add(1, 'days'),
              current,
              value,
            )
          }
        } else {
          return functioncheckMandatory(
            arrMandatory,
            //check empty range picker
            value.plan_start
              ? current < moment(dataHeader.kickoff) ||
                  current > moment(dataHeader.closure)
              : current < moment(dataHeader.kickoff) ||
                  current > moment(dataHeader.closure).add(1, 'days'),
            current,
            value,
          )
        }
      }
    }
  }
  const functioncheckMandatory = (arrMandatory, lastcheck, current, value) => {
    let arrTrueFalseMandatory = []
    arrMandatory?.map((item, index) => {
      if (item.plan_start != null) {
        if (value.id != item.id) {
          arrTrueFalseMandatory.push(
            !(
              //check empty range picker
              (value.plan_start
                ? current < moment(item?.plan_start) || current > moment(item?.plan_end)
                : current < moment(item?.plan_start) ||
                  current > moment(item?.plan_end).add(1, 'days'))
            ),
          )
        }
      }
    })
    arrTrueFalseMandatory.push(lastcheck)

    let functionOR = false
    arrTrueFalseMandatory.map((item) => {
      if (item == true) {
        functionOR = true
      }
    })

    return functionOR
  }
  const [selectRange, setSelectRange] = useState(false)
  const CalendarWay = (val) => {
    if (val.target.placeholder == 'Start date') {
      setSelectRange('start')
    } else {
      setSelectRange('end')
    }
  }

  const modalSaveReschedule = () => {
    return (
      <ModalSaveRescd
        visibleModalSaveRescd={visibleModalSaveRescd}
        setVisibleModalSaveRescd={setVisibleModalSaveRescd}
        firstUpdate={firstUpdate}
        FetchScheduleByid={FetchScheduleByid}
        getDataViewlog={getDataViewlog}
        getErrorflow={getErrorflow}
        setOnChangeData={setOnChangeData}
        state={'reschedule'}
      />
    )
  }
  const modalSaveChange = () => {
    return (
      <ModalSaveChange
        visibleSaveChange={visibleSaveChange}
        setVisibleSaveChange={setVisibleSaveChange}
        path={click_path}
        setClick_path={setClick_path}
      />
    )
  }
  const modalHistory = () => {
    return (
      <ModalHistory
        visible={visibleHistory}
        setVisible={setVisibleHistory}
        data={data_log}
      />
    )
  }
  const [visibleErrAuto, setVisibleErrAuto] = useState(false)
  const modalErrAuto = () => {
    return (
      <ModalErrAuto
        visible={visibleErrAuto}
        setVisible={setVisibleErrAuto}
        err_type={overlap}
      />
    )
  }
  useEffect(async () => {
    if (dataTable.length != 0 && wrt === true) {
    }
    if (dataTable.length != 0) {
      if (firstUpdate.current) {
        setOverlap((prev) => ({
          ...prev,
          status: true,
          configDate: true,
          working_day: true,
        }))
      }
      setDisableSave(false)
      dataTable?.map((item) => {
        if (item.config_date || item.config_mandatory) {
          setDisableSave(true)
          if (firstUpdate.current) {
            setOverlap((prev) => ({
              ...prev,
              configDate: false,
            }))
          }
        }
        if (item.type === 'task') {
          if (item.status === 'Done' || item.status === 'In Progress') {
            if (firstUpdate.current) {
              setOverlap((prev) => ({
                ...prev,
                status: false,
              }))
            }
          }
        }
        if (item.day == 0) {
          if (firstUpdate.current) {
            setOverlap((prev) => ({
              ...prev,
              working_day: false,
            }))
          }
        }
      })
      setTimeout(() => {
        firstUpdate.current = false
      }, 1000)
    }
  }, [dataTable])
  useEffect(() => {
    if (wrt === true) {
      const j = [dataHeader.kickoff, dataHeader.closure]
      PROJECT_CHANGED_DAYS(j)
    }
  }, [wrt])
  const onChangeTaskProject = (e, value, type) => {
    if (valueRadio == 2 && value.type != 'subtask') {
      if (e != null) {
        let dataArray = {}
        if (type == 'project') {
          // check repeat notification
          setId_onChange('project')
          dataArray = {
            kickoff: moment(e[0]).format('YYYY-MM-DD'),
            closure: moment(e[1]).format('YYYY-MM-DD'),
            type: 'project',
          }
        } else {
          // check repeat notification
          setId_onChange(value.id)
          dataArray = {
            sprintflow_id: value.id,
            kickoff: dataHeader.kickoff,
            closure: dataHeader.closure,
            plan_start: moment(e[0]).format('YYYY-MM-DD'),
            plan_end: moment(e[1]).format('YYYY-MM-DD'),
            type: 'task',
          }
        }
        projectScheduleAutoEdit({
          id: id,
          token: token,
          params: dataArray,
        })
          .then(async (response) => {
            const { status, data, error } = response
            if (error) {
              setDataschedule()
              setIsLoading(false)
              return true
            }
            if (status === 200) {
              if (type == 'project') {
                if (id_onChange != type) {
                  openNotificationWithIcon(
                    'success',
                    'Planned start and end dates has been changed',
                  )
                }
              } else {
                if (id_onChange != value.id) {
                  openNotificationWithIcon(
                    'success',
                    'Planned start and end dates has been changed',
                  )
                }
              }

              setDataschedule(data)
            } else {
              setDataschedule()
              setIsLoading(false)
              return true
            }
          })
          .catch((error) => {
            setDataschedule()
            setIsLoading(false)
            console.error(error)
          })
      }
    }
  }
  const colorStatus = (val) => {
    return val.status === 'To Do'
      ? 'status-ToDo '
      : val.status === 'Done'
      ? 'status-Done'
      : val.status === 'In Progress'
      ? 'status-InProgress'
      : val.status === 'Done(delayed)'
      ? 'status-Done-Delayed'
      : val.status === 'In Progress(delayed)'
      ? 'status-InProgress-Delayed'
      : 'status-hold'
  }
  const RangPickerTask = (item) => {
    return (
      <RangePicker
        className={`range-picker-reschedule ${
          item.config_date === true || item.config_mandatory === true
            ? 'error-rangpicker-styles '
            : ''
        }`}
        allowClear={false}
        onCalendarChange={(e) => onChangeDateTask(e, item)}
        onOpenChange={(e) => onOpenChange(e, item)}
        onBlur={onBlur}
        onFocus={(e) => CalendarWay(e)}
        size="large"
        style={{ marginRight: 8 }}
        onChange={(e) => onChangeTaskProject(e, item)}
        disabledDate={(e) => disableDateTask(e, item)}
        disabled={[item.disabled_start, item.disabled_end]}
        value={[
          item.plan_start === null ? null : moment(item.plan_start),
          item.plan_end === null ? null : moment(item.plan_end),
        ]}
      />
    )
  }
  const tooltipErr = (item) => {
    return (
      <Tooltip placement="left" title={item.tooltext}>
        <ExclamationCircleOutlined
          style={
            item.config_date === true || item.config_mandatory === true
              ? { visibility: 'visible' }
              : { visibility: 'hidden' }
          }
          className={'infor-error-date'}
        />
      </Tooltip>
    )
  }

  return (
    <div className="reschedule-container-main">
      <div className="header-schedule">
        <Row className="breadcrump-reschedule-styles">
          <h4
            className="text1"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              isDirty ? setVisibleSaveChange(true) : history.push('/project-list'),
                isDirty ? setClick_path('/project-list') : setClick_path()
            }}
          >
            Project
          </h4>
          <RightOutlined className="rightoutlined" />
          <div style={{ display: 'grid' }}>
            <h4 className="text2 cutter-text-line-1">{dataHeader?.name}</h4>
          </div>
        </Row>
        <div style={{ display: 'grid' }}>
          <TextTitleBold className="title-project cutter-text-line-1">{dataHeader?.name}</TextTitleBold>
        </div>
      </div>
      <div className="body-schedule">
        <div className="zone-1">
          <div className="l">
            <Row className="l-between">
              <Col>
                <Row className="l3">
                  <h3>How to reschedule? </h3>
                  <Radio.Group
                    className="radio-group"
                    onChange={onChangeRadio}
                    value={dataTable.length > 0 ? valueRadio : ''}
                    disabled={dataTable.length > 0 ? false : true}
                  >
                    <Radio id="manual_click" value={1}>
                      Manual
                    </Radio>
                    <Radio id="auto_click" value={2}>
                      Auto
                    </Radio>
                  </Radio.Group>
                </Row>
                <Row className="l1">
                  <h4 className="l1-1">Project :</h4>
                  <div style={{ display: 'grid' }}>
                    <h4 className="l1-2 cutter-text-line-1">{dataHeader?.name}</h4>
                  </div>
                </Row>
                <Row className="l2">
                  <h4>Kick off date/ Planned closures date :</h4>
                  <RangePicker
                    id="rangpicker_project"
                    className="range-picker-history"
                    onOpenChange={(e) => onOpenChangePlanProject(e)}
                    onChange={onChangplanProject}
                    disabledDate={(e) => disableDateProject(e)}
                    size="large"
                    allowClear={false}
                    onFocus={(e) => CalendarWay(e)}
                    style={{ marginRight: 8 }}
                    value={
                      dataHeader?.kickoff == null
                        ? [null, null]
                        : [moment(dataHeader.kickoff), moment(dataHeader.closure)]
                    }
                  />
                </Row>
              </Col>
              <Col>
                <Button
                  style={{ marginRight: 8 }}
                  className="BTN_ClassA"
                  onClick={(e) => window.location.reload()}
                >
                  <ReloadOutlined className="Icon-color " /> Reset
                </Button>
                <Button
                  className="BTN_ClassA"
                  onClick={() => {
                    setVisibleHistory(true), getDataViewlog()
                  }}
                  hidden={data_log.length > 0 ? false : true}
                  id="history"
                >
                  <EyeOutlined className="Icon-color " /> View history
                </Button>
              </Col>
            </Row>
          </div>
        </div>
        <div className="zone-2">
          <table className="table-styles-schedule">
            <thead>
              <tr className="header-table-schedule">
                <th>
                  <h5>Task</h5>
                </th>
                <th>
                  <h5>Subtask</h5>
                </th>
                <th style={{ paddingLeft: 36 }}>
                  <h5>Plan start / Plan end</h5>
                </th>
                <th>
                  <h5>Working days</h5>
                </th>
                <th>
                  <h5>Status</h5>
                </th>
              </tr>
            </thead>

            <tbody className="tbody-styles">
              {dataTable.map((item, idx) => {
                return (
                  <tr
                    className="body-table-schedule"
                    style={{
                      background: item.bgcolorCode,
                      maxHeight: 100,
                      overflow: 'hidden',
                    }}
                    key={idx}
                  >
                    {item.type === 'task' ? (
                      <td
                        style={{
                          display: 'flex',
                          flexWrap: 'nowrap',
                          minWidth: 100,
                        }}
                      >
                        <div style={{ display: 'grid', maxWidth: 200 }}>
                          <p
                            className="cutter-text-line-1"
                            style={{ color: `${item.textcolorCode}` }}
                          >
                            {item.title}
                          </p>
                        </div>

                        {item.task_type === 'M' ? (
                          <Tooltip placement="right" title="Mandatory Task">
                            <div className="tasktype-style-mandatory">
                              <span className="smallStatus">M</span>
                            </div>
                          </Tooltip>
                        ) : (
                          <></>
                        )}
                      </td>
                    ) : (
                      <td></td>
                    )}
                    {item.type === 'subtask' ? (
                      <td>
                        <div style={{ display: 'grid', maxWidth: 200 }}>
                          <p
                            className="cutter-text-line-1"
                            style={{ color: `${item.textcolorCode}` }}
                          >
                            {item.title}
                          </p>
                        </div>
                      </td>
                    ) : (
                      <td></td>
                    )}

                    <td
                      style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        alignItems: 'center',
                      }}
                    >
                      {tooltipErr(item)}
                      {RangPickerTask(item)}
                    </td>
                    <td>
                      <Row>
                        <p
                          style={
                            item.day == 0
                              ? { color: '#ffaf00' }
                              : { color: `${item.textcolorCode}` }
                          }
                        >
                          {item.day}
                        </p>
                        {item.day == 0 ? (
                          <Tooltip
                            placement="left"
                            title="Start/end date is holiday ,Working days equal to 0 days."
                          >
                            <ExclamationCircleOutlined
                              style={{ marginLeft: 8 }}
                              className="no-workingday-style"
                            />
                          </Tooltip>
                        ) : (
                          ''
                        )}
                      </Row>
                    </td>
                    <td>
                      <p style={{ color: `${item.textcolorCode}` }}>{item.status}</p>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <div className="container-card-responsive-reschedule">
            <div className="container-card-reschedule">
              {dataTable.map((item) => {
                if (item.type === 'task') {
                  return (
                    <div className="task">
                      <Row className="row1" style={{ flexWrap: 'nowrap' }}>
                        <div>
                          <p className="small">Task</p>
                          <Row style={{ flexWrap: 'nowrap' }}>
                            <div style={{ display: 'grid' }}>
                              <p className="cutter-text-line-1">{item.title}</p>
                            </div>
                            {item.task_type === 'M' ? (
                              <Tooltip placement="right" title="Mandatory Task">
                                <div className="tasktype-style-mandatory">
                                  <span className="smallStatus">M</span>
                                </div>
                              </Tooltip>
                            ) : (
                              <></>
                            )}
                          </Row>
                        </div>
                        <div style={{ minWidth: 'fit-content' }}>
                          <div className={`Status  ${colorStatus(item)}`}>
                            <span className="smallStatus ">{item.status}</span>
                          </div>
                        </div>
                      </Row>
                      <Col className="col1-task">
                        <p className="small">Plan start / Plan end</p>
                        <Row className="col1-incol">
                          {RangPickerTask(item)}
                          {tooltipErr(item)}
                          <p
                            className="smallStatus"
                            style={item.day == 0 ? { color: '#ffaf00' } : { color: '' }}
                          >
                            {' '}
                            {item.day} {item.day === 1 ? 'day' : 'days'}
                          </p>
                        </Row>
                      </Col>
                    </div>
                  )
                } else {
                  return (
                    <div className="subtask">
                      <div className="box">
                        <Row className="row1-sub" style={{ flexWrap: 'nowrap' }}>
                          <div>
                            <p className="small">Subtask</p>
                            <div style={{ display: 'grid' }}>
                              <p className="cutter-text-line-1">{item.title}</p>
                            </div>
                          </div>
                          <div style={{ minWidth: 'fit-content', height: 'fit-content' }}>
                            <div className={`Status ${colorStatus(item)}`}>
                              <span className="smallStatus ">{item.status}</span>
                            </div>
                          </div>
                        </Row>
                        <Col className="col1-sub">
                          <p className="small">Plan start / Plan end</p>
                          <Row className="col1-incol">
                            {RangPickerTask(item)}
                            {tooltipErr(item)}
                            <p
                              className="smallStatus"
                              style={item.day == 0 ? { color: '#ffaf00' } : { color: '' }}
                            >
                              {' '}
                              {item.day} {item.day === 1 ? 'day' : 'days'}
                            </p>
                          </Row>
                        </Col>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          </div>
        </div>
        <div className="zone-3">
          <Button
            className="BTN_Previous"
            onClick={() => {
              history.push('/project-list'), setDirty(false)
            }}
            id="cancel_reschedule"
          >
            <CloseCircleOutlined className="Icon-color" /> Cancel
          </Button>
          <Button
            className="BTN_Next"
            disabled={onChangeData && !disableSave ? false : true}
            onClick={() => setVisibleModalSaveRescd(true)}
            id="ok_reschedule"
          >
            <SaveOutlined className="Icon-color" /> Save
          </Button>
        </div>
      </div>
      {modalSaveReschedule()}
      {modalHistory()}
      {modalErrAuto()}
      {modalSaveChange()}
    </div>
  )
}

export default Reschedule
